import type { FeatureTarget } from "./domStyles";

export const FEATURE_TARGETS: Record<string, FeatureTarget> = {
  "highlight-links": "both",
  "highlight-titles": "both",
  "align-text": "page",
  "pause-animations": "page",
  "bigger-cursor": "both",
  "hide-images": "page",
  "dyslexic-font": "both",
  "legible-font": "both",
  "background-color": "page",
  "text-color": "page",
  "high-saturation": "both",
  "low-saturation": "both",
  monochrome: "both",
  "invert-colors": "both",
  "high-contrast": "page",
  "dark-contrast": "page",
  "light-contrast": "page",
};

export function getFeatureTarget(
  featureId: string,
  fallback: FeatureTarget = "page",
): FeatureTarget {
  return FEATURE_TARGETS[featureId] ?? fallback;
}
